import React, { useState, useEffect, useRef } from 'react';

import { Status as StatusInterface, DateRange } from '../../../types';
import { fetchGlanceData } from './../helpers';

import Graph from './../components/Graph';

interface Props {
  dateRange: DateRange;
  setFetching: (fetching: boolean) => void;
  currency?: string;
}

const SalesSegment = ({ dateRange, setFetching, currency }: Props): React.ReactElement => {
  const [glanceSalesGraph, setGlanceSalesGraph] = useState<any>();
  const [status, setStatus] = useState<StatusInterface[]>([]);

  const lineGraphEl: any = useRef(null);
  const [showDownloadOptions, setShowDownloadOptions] = useState<boolean>(false);

  const fetchGlanceGraph = async (params: any, path: string) => {
    setFetching(true);

    (async () => {
      try {
        const data = await fetchGlanceData(path, params);
        setGlanceSalesGraph(data && data.values);
        setFetching(false);
      } catch (error: any) {
        setStatus([...status, { state: 'error', message: error }]);
        setFetching(false);
      }
    })();
  };

  useEffect(() => {
    //reset
    resetSalesGraph();

    const params = {
      startDate: dateRange.startDate,
      endDate: dateRange.endDate
    };
    const path = 'atglance/sales/graph';

    fetchGlanceGraph(params, path);
  }, []);

  const resetSalesGraph = () => {
    setGlanceSalesGraph(null);
  };

  return (
    <Graph
      currencyCode={currency}
      graphData={glanceSalesGraph}
      showDownloadOptions={showDownloadOptions}
      setShowDownloadOptions={setShowDownloadOptions}
      lineGraphEl={lineGraphEl}
    />
  );
};

export default SalesSegment;
